<template>
  <div v-if="categoria">
    <v-row
      v-if="lista.length > 0"
      class="mt-8"
      dense
    >
      <h2 class="title primary--text text--darken-1 text-no-wrap mt-0 ml-2">
        {{ titulo }}
      </h2>
    </v-row>
    <v-row
      class="mt-0"
      dense
    >
      <v-col cols="12">
        <v-card flat>
          <v-card-text>
            <v-row
              v-if="lista.length > 0"
              dense
            >
              <v-col>
                <v-autocomplete
                  v-model="areasSelecionadas"
                  :items="listaAreas"
                  :prepend-icon="icone"
                  :rules="[
                    () =>
                      areasSelecionadas.length <= maximoAreas ||
                      `Informe no máximo ${maximoAreas} áreas`,
                  ]"
                  :search-input.sync="search"
                  chips
                  class="mr-4"
                  color="primary"
                  counter
                  deletable-chips
                  item-text="nome"
                  label="Digite ou selecione as áreas"
                  placeholder="Digite para pesquisar..."
                  multiple
                  outlined
                  required
                  return-object
                  validate-on-change
                  @change="
                    select();
                    search = '';
                  "
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :input-value="data.selected"
                      class="chip--select-multi"
                      close
                      color="secondary"
                      search=""
                      text-color="white"
                      @click:close="remove(data.item)"
                    >
                      {{ data.item.nome }}
                    </v-chip>
                  </template>
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          A área
                          <strong class="secondary--text">{{ search }}</strong>
                          não foi encontrada.
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:counter>
                    <v-chip text-color="secondary">
                      <v-avatar
                        color="secondary"
                        left
                        text-color="white"
                      >
                        <span class="white--text">{{
                          areasSelecionadas.length
                        }}</span>
                      </v-avatar>
                      áreas selecionadas
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>

              <!-- adicionar área -->
              <v-col
                v-if="permiteCriarArea"
                cols="12"
                md="1"
              >
                <v-menu
                  v-model="dialogAdicionarArea.visibilidade"
                  :close-on-content-click="false"
                  :nudge-width="500"
                  offset-y
                >
                  <!-- botão -->
                  <template v-slot:activator="{ on: menu }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                          color="secondary"
                          dark
                          fab
                          small
                          v-on="{ ...tooltip, ...menu }"
                        >
                          <v-icon>add</v-icon>
                        </v-btn>
                      </template>
                      <span>Clique no botão para adicionar uma nova área</span>
                    </v-tooltip>
                  </template>

                  <v-card class="pa-5">
                    <!-- título -->
                    <v-card-title>
                      <v-row class="d-flex flex-column text-lg-center">
                        <h5 class="headline primary--text text-no-wrap">
                          Adicionar Área de {{ categoria.nome }}
                        </h5>
                        <span class="subtitle-1">Informe o nome da Área</span>
                      </v-row>
                    </v-card-title>

                    <!-- campo -->
                    <v-card-text>
                      <v-form
                        ref="formArea"
                        v-model="dialogAdicionarArea.valid"
                        @submit.prevent="adicionarArea()"
                      >
                        <v-row>
                          <v-text-field
                            v-model.trim="area.nome"
                            :rules="[
                              (n) => !!n || 'O nome da área não pode ser vazio',
                              (n) =>
                                !areaJaExiste(n) ||
                                'Este nome de área já existe',
                            ]"
                            label="Nome da Área"
                            required
                          />
                        </v-row>
                      </v-form>
                    </v-card-text>

                    <!-- botões -->
                    <v-card-actions>
                      <v-row class="justify-end mr-4">
                        <v-btn
                          :disabled="area.nome === ''"
                          class="mr-2"
                          color="primary"
                          @click="adicionarArea()"
                        >
                          Adicionar
                        </v-btn>
                        <v-btn
                          color="primary"
                          outlined
                          @click="dialogAdicionarArea.visibilidade = false"
                        >
                          Cancelar
                        </v-btn>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>

            <!-- instrutor -->
            <v-row
              v-if="mostrarInstrutor"
              class="justify-end"
              dense
            >
              <v-col>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col>
                        <h4>
                          Você tem interesse em ser
                          <span
                            class="secondary--text"
                          >Instrutor de {{ categoria.nome }}</span>?
                        </h4>
                        <v-radio-group
                          v-model="opcao"
                          row
                          @change="confirm"
                        >
                          <v-radio
                            :value="true"
                            label="Sim"
                          />
                          <v-radio
                            :value="false"
                            label="Não"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="opcao"
                      dense
                    >
                      <v-col>
                        <curso-instrutor-form
                          :maximo="maximoCursos"
                          :tipo="tipo"
                          :titulo="`Indique o(s) curso(s) (Máximo ${maximoCursos})`"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CursoInstrutorForm from '@/components/perfil/CursoInstrutorForm';
import _ from 'lodash';

const DEFAULT_AREA = () => ({ nome: null, id: null, tipo: null });

export default {
  name: 'AreasPerfilSelect',

  components: { CursoInstrutorForm },

  props: {
    areas: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    lista: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    maximoAreas: {
      type: Number,
      default: 5,
      required: false,
    },
    maximoCursos: {
      type: Number,
      default: 5,
      required: false,
    },
    instrutor: {
      type: Boolean,
      default: null,
      required: false,
    },
    mostrarInstrutor: {
      type: Boolean,
      default: true,
    },
    tipo: {
      type: String,
      default: 'CAPACITACAO',
      required: false,
    },
    icone: {
      type: String,
      default: 'checklist',
      required: false,
    },
    permiteCriarArea: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      search: '',
      areasSelecionadas: this.areas ? _.sortBy(this.areas.slice(), (i) => i.nome.toLowerCase()) : [],
      listaAreas: this.lista ? this.lista : [],
      opcao: this.instrutor,
      dialogAdicionarArea: { visibilidade: false },
      area: DEFAULT_AREA(),
    };
  },

  computed: {
    listaAreasLower() {
      return this.listaAreas.map((a) => a.nome.toLowerCase());
    },
    titulo() {
      return `ÁREAS DE ${this.categoria.nome.toUpperCase()} (MÁXIMO ${this.maximoAreas})`;
    },
    categoria() {
      switch (this.tipo) {
        case 'CULTURA':
          return {
            nome: 'Cultura e Arte',
          };
        case 'ESPORTE':
          return {
            nome: 'Esporte',
          };
        case 'CAPACITACAO':
          return {
            nome: 'Capacitação',
          };
        case 'ATUACAO':
          return {
            nome: 'Atuação',
          };
        default:
          return null;
      }
    },
  },

  watch: {
    areas(value) {
      this.areasSelecionadas = value;
    },
    instrutor(value) {
      this.opcao = value;
    },
    lista(value) {
      this.listaAreas = value;
    },
  },

  methods: {
    areaJaExiste(nome) {
      if (nome) {
        nome = nome.toLowerCase();
        return this.listaAreasLower.findIndex((n) => n === nome) !== -1;
      }
    },
    select() {
      if (_.size(this.areasSelecionadas) <= this.maximoAreas) {
        this.$emit('return', this.areasSelecionadas);
      } else {
        this.$store.dispatch('app/error', {
          message: `É necessário remover áreas de ${this.categoria.nome.toLowerCase()} até o
            limite de ${this.maximoAreas} itens`,
        });
      }
    },
    confirm() {
      this.$emit('confirm', this.opcao);
    },
    remove(area) {
      if (area.id == null) {
        this.areasSelecionadas = this.areasSelecionadas.filter((a) => a.nome !== area.nome);
        this.listaAreas = this.listaAreas.filter((a) => a.nome !== area.nome);
      } else {
        this.areasSelecionadas = this.areasSelecionadas.filter((a) => a.id !== area.id);
        this.listaAreas = this.listaAreas.filter((a) => a.id !== area.id);
      }
      this.$emit('return', this.areasSelecionadas);
    },
    adicionarArea() {
      this.area.tipo = this.tipo;
      this.listaAreas.push(this.area);
      this.listaAreas = _.sortBy(this.listaAreas, (i) => i.nome.toLowerCase());
      this.areasSelecionadas.push(this.area);
      this.areasSelecionadas = _.sortBy(this.areasSelecionadas, (i) => i.nome.toLowerCase());
      this.select();
      this.area = DEFAULT_AREA();
      this.dialogAdicionarArea.visibilidade = false;
      this.$refs.formArea.resetValidation();
    },
  },
};
</script>
